module.exports = __webpack_public_path__ + "static/hollee-kier.607dec4e.webp";